$(document).ready(function() {
  $('.product_features_wrapper .sec_header, .m7-specification-section .sec-heading').click(function() {
    var newWindowWidth = $(window).width();
    if (newWindowWidth < 767) {
      $(this).next().slideToggle();
      $(this).toggleClass('active');
    }
  })
  
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      },
    },
  });
  
  new Swiper(".swiper-ugc", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next_ugc",
      prevEl: ".swiper-button-prev_ugc",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      },
    },
  });
  
                              
  $('.video_poster_img').mouseover(function() {
    $('.video_poster_img').removeClass('hideback');
    $('.playbtn').show();
    $('.videin').each(function() {
        $(this).get(0).pause();
    });
    $(this).parents('.ugc-video-item').find('.videin')[0].play();
    $(this).parents('.ugc-video-item').find('.playbtn').hide();
    
    $(this).addClass('hideback');
  })

  $(".ugc-video-item").hover(
    function () {
      $(".ugc-video-item").removeClass("active");
      $(this).addClass("active");
    },
    function () {
      // $(this).removeClass("result_hover");
    }
  );

  

var swiperA = new Swiper(".collection-swiper", {
  slidesPerView: 1.2,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next-c",
    prevEl: ".swiper-button-prev-c",
  },
  breakpoints: {
    640: {
      slidesPerView: 1.2
    },
    768: {
      slidesPerView: 3
    },
    1024: {
      slidesPerView: 4
    },
  },
});

$('button.button.filter_show_hide').click(function() {
  $(this).toggleClass('active')
  $('aside#main-collection-filters').toggleClass('hidden');

  if($(this).hasClass('active')) {
    $('#product-grid').removeClass('grid--3-col-desktop');
    $('#product-grid').addClass('grid--4-col-desktop');
  } else {
    $('#product-grid').addClass('grid--3-col-desktop');
    $('#product-grid').removeClass('grid--4-col-desktop');
  }
})

})
